export default __webpack_public_path__ + "static/media/Sweet-16-Cake.bb33d90f.jpg";